import _extends from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends";
import React from "react";
var __jsx = React.createElement;
import { TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { useCallback, useMemo, useState } from 'react';
import { connectRefinementList } from 'react-instantsearch-core';
import { FormattedMessage } from 'react-intl';
import { useDebounce } from 'react-use';
import { SEARCH_DEBOUNCE_MS } from 'config/algolia/ux';
import { Container } from './AuthorFilter.style';

var AuthorFilter = function AuthorFilter(_ref) {
  var items = _ref.items,
      currentRefinement = _ref.currentRefinement,
      fieldLabelIdPrefix = _ref.fieldLabelIdPrefix,
      refine = _ref.refine,
      searchForItems = _ref.searchForItems;

  var _useState = useState(''),
      inputValue = _useState[0],
      setInputValue = _useState[1];

  var options = useMemo(function () {
    return items.map(function (_ref2) {
      var label = _ref2.label;
      return label;
    });
  }, [items]);
  var handleChange = useCallback(function (event, value) {
    refine([value !== null && value !== void 0 ? value : '']);
  }, [refine]);
  useDebounce(function () {
    searchForItems(inputValue);
  }, SEARCH_DEBOUNCE_MS, [inputValue, searchForItems]);
  return __jsx(Container, null, __jsx(Autocomplete, {
    options: options,
    onChange: handleChange,
    value: currentRefinement.length === 0 ? null : currentRefinement[0],
    onInputChange: function onInputChange(event, value) {
      return setInputValue(value);
    },
    renderInput: function renderInput(params) {
      return __jsx(TextField, _extends({}, params, {
        label: __jsx(FormattedMessage, {
          id: "".concat(fieldLabelIdPrefix, ".label")
        }),
        variant: "outlined"
      }));
    } // Setting `filterOptions` as the identity function allows to let algolia do the filtering
    ,
    filterOptions: function filterOptions(algoliaOptions) {
      return algoliaOptions;
    }
  }));
};

export default connectRefinementList(AuthorFilter);